import { render, staticRenderFns } from "./HotspotQuestion.vue?vue&type=template&id=785d943c&scoped=true"
import script from "./HotspotQuestion.vue?vue&type=script&lang=js"
export * from "./HotspotQuestion.vue?vue&type=script&lang=js"
import style0 from "./HotspotQuestion.vue?vue&type=style&index=0&id=785d943c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785d943c",
  null
  
)

export default component.exports